var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgParcelowlLogo6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "24f1d249a3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 85.578125 L 187.5 85.578125 L 187.5 273.078125 L 0 273.078125 Z M 0 85.578125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "13d254293d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 93.75 85.578125 C 41.972656 85.578125 0 127.550781 0 179.328125 C 0 231.105469 41.972656 273.078125 93.75 273.078125 C 145.527344 273.078125 187.5 231.105469 187.5 179.328125 C 187.5 127.550781 145.527344 85.578125 93.75 85.578125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5227170e3e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 179.328125 L 53 179.328125 L 53 289.421875 L 0 289.421875 Z M 0 179.328125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "00c82c2347"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 56.175781 141.753906 L 131.324219 141.753906 L 131.324219 216.90625 L 56.175781 216.90625 Z M 56.175781 141.753906 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9a66c58598"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 93.75 141.753906 C 72.996094 141.753906 56.175781 158.578125 56.175781 179.328125 C 56.175781 200.082031 72.996094 216.90625 93.75 216.90625 C 114.503906 216.90625 131.324219 200.082031 131.324219 179.328125 C 131.324219 158.578125 114.503906 141.753906 93.75 141.753906 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5e7e04366d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 187.5 85.578125 L 375 85.578125 L 375 273.078125 L 187.5 273.078125 Z M 187.5 85.578125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c89e2434c7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 281.25 85.578125 C 229.472656 85.578125 187.5 127.550781 187.5 179.328125 C 187.5 231.105469 229.472656 273.078125 281.25 273.078125 C 333.027344 273.078125 375 231.105469 375 179.328125 C 375 127.550781 333.027344 85.578125 281.25 85.578125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c9c7ba4478"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 243.675781 141.753906 L 318.824219 141.753906 L 318.824219 216.90625 L 243.675781 216.90625 Z M 243.675781 141.753906 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "088105dfcc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 281.25 141.753906 C 260.496094 141.753906 243.675781 158.578125 243.675781 179.328125 C 243.675781 200.082031 260.496094 216.90625 281.25 216.90625 C 302.003906 216.90625 318.824219 200.082031 318.824219 179.328125 C 318.824219 158.578125 302.003906 141.753906 281.25 141.753906 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9e014fdb44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 68.605469 154.183594 L 118.894531 154.183594 L 118.894531 204.472656 L 68.605469 204.472656 Z M 68.605469 154.183594 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "04d894c4f9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 93.75 154.183594 C 79.863281 154.183594 68.605469 165.441406 68.605469 179.328125 C 68.605469 193.214844 79.863281 204.472656 93.75 204.472656 C 107.636719 204.472656 118.894531 193.214844 118.894531 179.328125 C 118.894531 165.441406 107.636719 154.183594 93.75 154.183594 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9a63f479bc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 256.105469 154.183594 L 306.394531 154.183594 L 306.394531 204.472656 L 256.105469 204.472656 Z M 256.105469 154.183594 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "eaae0600dd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 281.25 154.183594 C 267.363281 154.183594 256.105469 165.441406 256.105469 179.328125 C 256.105469 193.214844 267.363281 204.472656 281.25 204.472656 C 295.136719 204.472656 306.394531 193.214844 306.394531 179.328125 C 306.394531 165.441406 295.136719 154.183594 281.25 154.183594 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: 9355589303
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 155 226 L 218 226 L 218 289 L 155 289 Z M 155 226 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bf26a28dac"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 155.859375 259.503906 L 186.890625 224.371094 L 222.023438 255.402344 L 190.992188 290.535156 Z M 155.859375 259.503906 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "03d0aba1c0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 155.859375 259.503906 L 185.269531 226.203125 L 219.140625 256.117188 L 189.726562 289.417969 Z M 155.859375 259.503906 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#24f1d249a3)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#13d254293d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#695cfe",
    d: "M 0 85.578125 L 187.5 85.578125 L 187.5 273.078125 L 0 273.078125 Z M 0 85.578125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5227170e3e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#695cfe",
    d: "M 0 179.328125 L 52.734375 179.328125 L 52.734375 290.65625 L 0 290.65625 Z M 0 179.328125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#00c82c2347)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9a66c58598)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 56.175781 141.753906 L 131.324219 141.753906 L 131.324219 216.90625 L 56.175781 216.90625 Z M 56.175781 141.753906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5e7e04366d)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c89e2434c7)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#695cfe",
    d: "M 187.5 85.578125 L 375 85.578125 L 375 273.078125 L 187.5 273.078125 Z M 187.5 85.578125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c9c7ba4478)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#088105dfcc)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 243.675781 141.753906 L 318.824219 141.753906 L 318.824219 216.90625 L 243.675781 216.90625 Z M 243.675781 141.753906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9e014fdb44)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#04d894c4f9)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#695cfe",
    d: "M 68.605469 154.183594 L 118.894531 154.183594 L 118.894531 204.472656 L 68.605469 204.472656 Z M 68.605469 154.183594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9a63f479bc)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eaae0600dd)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#695cfe",
    d: "M 256.105469 154.183594 L 306.394531 154.183594 L 306.394531 204.472656 L 256.105469 204.472656 Z M 256.105469 154.183594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9355589303)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bf26a28dac)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#03d0aba1c0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#695cfe",
    d: "M 155.859375 259.503906 L 184.949219 226.566406 L 217.886719 255.65625 L 188.796875 288.59375 Z M 155.859375 259.503906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParcelowlLogo6);
export default __webpack_public_path__ + "static/media/Parcelowl-logo-6.2ae0ac4532b9c0279371c7b36862d958.svg";
export { ForwardRef as ReactComponent };